// Pull the backend-provided OutcomeTools reason from a failed link/sync call,
// falling back to a generic message. Keeps the three provisioning entry points
// (the OutcomeTools card, the program dialog, and the episode/contact-edit
// dialog) consistent — the backend already returns a per-field message via
// OutcomeToolsApiService::formatErrorMessage (e.g. "OutcomeTools API: DOB is a
// required field.").
//
// error  — the rejected error from useOutcomeToolsSorApi().linkPatient()
// prefix — optional context to prepend when a specific reason exists
//          (e.g. "Patient saved, but could not be added to OutcomeTools℠: ")
// fallback — shown when the backend returns no specific message
export function outcomeToolsLinkErrorMessage(error, { fallback, prefix } = {}) {
    const detail = error?.response?.data?.error;
    if (detail) return prefix ? `${prefix}${detail}` : detail;
    return fallback;
}
